import type { JSX } from 'react';

import type { PetitionDetails } from 'src/app/pages/petition/details/shared/types';

import { OrganizationLink } from './OrganizationLink';
import { UserLink } from './UserLink';

type Props = Readonly<{
	user: PetitionDetails['user'];
	organization: PetitionDetails['organization'];
}>;

export function StarterLink({ user, organization }: Props): JSX.Element {
	return organization ? <OrganizationLink organization={organization} /> : <UserLink user={user} />;
}
